import { Component, OnInit, Renderer2 } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { SharedService } from "../services/shared.service";
import {Location} from '@angular/common';

@Component({
    selector: 'server-error',
    templateUrl: './server-error.component.html',
    styleUrls: ['./server-error.component.scss']
  })
  export class ServerErrorComponent implements OnInit {
    previousUrl: string;

    constructor(private router: Router,
        private sharedService: SharedService,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        private location: Location) {
    
        this.sharedService.setHeaderText('Server error');
    
        this.renderer.addClass(document.body, 'login-screen');   
       
      }
      
    ngOnInit(): void {
        
    }

    returnToPrevious(){       
      this.renderer.removeClass(document.body, 'login-screen');  
      this.location.back();
    }

  }